import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Navigator } from "src/app/components/menu/navigator";
import { UtilsService } from 'src/app/services/utils/utils.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-popover-alert',
  templateUrl: './popover-alert.component.html',
  styleUrls: ['./popover-alert.component.scss'],
})
export class PopoverAlertComponent implements OnInit {

  @Input() data: any;

  public imageUrl: string;
  public image: string;
  public buttonText: string;

  constructor(
    private sanitizer: DomSanitizer,
    public popoverController: PopoverController,
    public navigator: Navigator,
    public utils: UtilsService
  ) { }


  public onClosePopover() {
    this.popoverController.dismiss(true);
    this.notificationClose();
  }


  ngOnInit(): void {
    console.log(this.data.timeout, 'alert!');
    this.imageUrl = `/notifications/${this.data.notificationImage}`;
    this.image = this.utils?.getCDNAsset(this.imageUrl);

    if (this.data.timeout) {
      setTimeout(() => {
        this.onClosePopover();
      }, +this.data.timeout);
    }

    this.buttonText = this.data?.buttonText ?? 'Close';
  }

  get sanitizedHtmlText() {
    return this.sanitizer.bypassSecurityTrustHtml(this.data.htmlText);
  }

  notificationClose() {
    if (this.data.onCloseFunc) {
      this.data.onCloseFunc('closeButton');
    }
  }

}
